import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { KpiCard, PageHeader, StatusPill } from "@/components/common";
import { FileText, ArrowRight } from "lucide-react";

export default function BuyerDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [rfqs, setRfqs] = useState([]);
  useEffect(() => {
    api.get("/stats").then(r => setStats(r.data));
    api.get("/rfqs").then(r => setRfqs(r.data.slice(0, 6)));
  }, []);
  return (
    <>
      <PageHeader
        title={`Welcome, ${user?.full_name?.split(" ")[0] || "Buyer"}.`}
        subtitle="Your sourcing activity at a glance. Create an RFQ to source faster."
        actions={<Link to="/app/rfqs/new" data-testid="new-rfq-btn" className="btn btn-primary"><FileText size={16} /> New RFQ <ArrowRight size={14} /></Link>}
      />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 16, marginBottom: 28 }}>
        <KpiCard label="Active RFQs" value={stats?.active_rfqs ?? "—"} accent="var(--amber-400)" />
        <KpiCard label="Quoted RFQs" value={stats?.quoted_rfqs ?? "—"} />
        <KpiCard label="Awarded" value={stats?.awarded_rfqs ?? "—"} />
        <KpiCard label="Orders" value={stats?.orders ?? "—"} />
        <KpiCard label="Total Spend" value={`$${(stats?.total_spend ?? 0).toLocaleString()}`} sub="CAD · lifetime" />
      </div>
      <div className="card" data-testid="recent-rfqs">
        <div style={{ padding: "14px 18px", borderBottom: "1px solid var(--line)", display: "flex", justifyContent: "space-between" }}>
          <div className="font-mono" style={{ fontSize: 11, letterSpacing: ".1em", color: "var(--ink-mute)" }}>RECENT RFQs</div>
          <Link to="/app/rfqs" style={{ fontSize: 12, color: "var(--amber-400)" }}>View all →</Link>
        </div>
        {rfqs.length === 0 ? (
          <div style={{ padding: 32, textAlign: "center", color: "var(--ink-mute)" }}>
            No RFQs yet. <Link to="/app/rfqs/new" style={{ color: "var(--amber-400)" }}>Create your first RFQ</Link> to start sourcing.
          </div>
        ) : (
          <table className="data">
            <thead><tr><th>Code</th><th>Product</th><th>Qty</th><th>Region</th><th>Status</th><th>Created</th><th></th></tr></thead>
            <tbody>
              {rfqs.map(r => (
                <tr key={r.id}>
                  <td data-label="Code" className="font-mono" style={{ color: "var(--amber-400)" }}>{r.code}</td>
                  <td data-label="Product">{r.product_name}</td>
                  <td data-label="Qty">{r.quantity}</td>
                  <td data-label="Region">{r.delivery_region}</td>
                  <td data-label="Status"><StatusPill status={r.status} /></td>
                  <td data-label="Created" className="font-mono" style={{ color: "var(--ink-mute)", fontSize: 12 }}>{new Date(r.created_at).toLocaleDateString()}</td>
                  <td data-label=""><Link to={`/app/rfqs/${r.id}`} data-testid={`open-rfq-${r.code}`} className="btn btn-ghost" style={{ padding: "6px 12px", fontSize: 12 }}>Open</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
